var styles = {
  "HorizontalGrid": "Polaris-HorizontalGrid"
};

export { styles as default };
